import { useMemo } from 'react';

import { useDisplayLowestPrice } from '~/components/shared/recommendations/hooks/useDisplayLowestPrice';
import { useTileContext } from '~/components/shared/recommendations/tile/TileContext';
import { useStaticContext } from '~/utilities/context/static/StaticContext';
import { parseFormattedPrice } from '~/utilities/helpers/parseFormattedPrice';

export const useTileRenderLowestPrice = (): boolean | null | undefined => {
  const { priceFormatter } = useStaticContext();
  const { product } = useTileContext();

  const [parsedBasePrice, parsedFromPrice] = useMemo(() => {
    const basePrice = priceFormatter(product.priceValue);
    const fromPrice = priceFormatter(product.fromPriceValue);

    return [parseFormattedPrice(basePrice), parseFormattedPrice(fromPrice)];
  }, [product, priceFormatter]);

  const { renderLowestPrice } = useDisplayLowestPrice(parsedBasePrice, parsedFromPrice);

  return renderLowestPrice;
};
